import Context from "../context/context";
import React, { useContext } from 'react';

function Checkbox(props){
    const {data, handleClick} = props;
    const {selectedFilters} = useContext(Context);

    let selected = false;
    selectedFilters.forEach((selected_filter) => {
        if (selected_filter.name === data.parent){
            selected_filter.elements.forEach((element) => {
                if (element.selected && element.id == data.id) {
                    selected = !selected;
                }
            })
        }
    })

    return (
        <>
            <div className={`filter-checkbox ${selected ? "active" : ""}`} onClick={() => handleClick(data.id)}>
                {data.title}
            </div>

        </>
    )
}

export default Checkbox;
